
import flutter from "../images/flutter.png";
import python from "../images/python.png";
import java from "../images/java.png";
import js from "../images/js.png";

export const LinkData = [

  {
    id: 1,
    title: "Home",
    url: "/",
  },
  {
    id: 2,
    title: "Internship",
    url: "/internship",
  },
  {
    id: 3,
    title: "Resources",
    url: "/resources",
  },
  {
    id: 4,
    title: "Service",
    url: "/service",
  },
  {
    id: 5,
    title: "About",
    url: "/about",
  },
]
export const courses = [
  {
    id: 1,
    cover: python,
    title:"Python: A Serpentine Journey Through Code",
    lesson:"28 Chapter",
    type:"Paid",
    rate:"4.80(58)",
  },
  {
    id: 2,
    cover: java,
    title: "Java: The Evergreen Titan of Programming",
    lesson:"37 Chapter",
    type:"Free",
    rate:"3.90(27)",
  },
  {
    id: 3,
    cover: js,
    title: "JavaScript: A Journey Through the Web's Lifeline",
    lesson:"44 Chapter",
    type:"Paid",
    rate:"4.71(69)",
  },
  {
    id: 4,
    cover: flutter,
    title: "Flutter: Rapid App Development with Dart",
    lesson:"32 Chapter",
    type:"Free",
    rate:"3.50(18)",
  },
]
